import { useQuery } from "@tanstack/react-query";

import { supplierQueryKeys } from "./query-keys";
import { getSupplierInvitationStatus } from "./supplier.api";

/**
 * Whether the logged-in user's email matches a pending supplier invitation. Backed by the
 * un-permission-gated `network/suppliers/invitation-status` endpoint, so it stays callable for a
 * user who lacks the `network-supplier-v2` access permission.
 */
export const useSupplierInvitationStatus = ({ enabled }: { enabled: boolean }) =>
  useQuery({
    queryKey: supplierQueryKeys.invitationStatus(),
    queryFn: getSupplierInvitationStatus,
    enabled,
  });
